// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"daa6f663","238":"e49b1137","239":"e6ea3c50","316":"fbb7b9a4","557":"2c2892ba","667":"af460134","762":"876a16ff"}[chunkId] + ".chunk.js";
};